module.exports = {
      id: "compare-usage",
      viewBox: "0 0 17.1 17",
      url: __webpack_public_path__ + "img/icons.a7e6c507.svg#compare-usage",
      toString: function () {
        return this.url;
      }
    }